// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "primary-2PYHd";
var _3 = "secondary-FKZH_";
export { _1 as "__esModule", _2 as "primary", _3 as "secondary" }
export default { "__esModule": _1, "primary": _2, "secondary": _3 }
